import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation, Link } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Loader2 } from "lucide-react";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login, { AuthCallback } from "@/pages/Login";
import Food from "@/pages/Food";
import Market from "@/pages/Market";
import Wallet from "@/pages/Wallet";
import P2P from "@/pages/P2P";
import Orders from "@/pages/Orders";
import Profile from "@/pages/Profile";
import Driver from "@/pages/Driver";
import Admin from "@/pages/admin/Admin";
import Terms from "@/pages/Terms";
import Support from "@/pages/Support";
import Reset from "@/pages/Reset";
import Messages from "@/pages/Messages";
import Uber from "@/pages/Uber";
import Games from "@/pages/Games";
import PokerTable from "@/pages/PokerTable";
import DominoTable from "@/pages/DominoTable";
import Predictions from "@/pages/Predictions";

function Protected({ children, staffOnly = false }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === undefined) return <div className="min-h-screen flex items-center justify-center text-muted-foreground"><Loader2 className="animate-spin mr-2" /> Cargando…</div>;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (staffOnly && !["admin", "staff"].includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/reset" element={<Reset />} />
      <Route path="/terminos" element={<div className="max-w-4xl mx-auto px-4 py-8"><Link to={-1} data-testid="terms-back-link" className="text-sm text-primary hover:underline">← Volver</Link><div className="mt-4"><Terms /></div></div>} />
      <Route element={<Protected><Layout /></Protected>}>
        <Route path="/" element={<Food />} />
        <Route path="/soporte" element={<Support />} />
        <Route path="/ventas" element={<Market />} />
        <Route path="/wallet" element={<Wallet />} />
        <Route path="/p2p" element={<P2P />} />
        <Route path="/pedidos" element={<Orders />} />
        <Route path="/perfil" element={<Profile />} />
        <Route path="/chofer" element={<Driver />} />
        <Route path="/mensajes" element={<Messages />} />
        <Route path="/uber" element={<Uber />} />
        <Route path="/juegos" element={<Games />} />
        <Route path="/juegos/poker/:id" element={<PokerTable />} />
        <Route path="/juegos/domino/:id" element={<DominoTable />} />
        <Route path="/predicciones" element={<Predictions />} />
        <Route path="/admin/*" element={<Protected staffOnly><Admin /></Protected>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-center" richColors theme="dark" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
